export enum ServiceAgreementStatusType {
    Active = 'Active',
    Sent = 'Sent',
    Canceled = 'Canceled',
    Fulfilled = 'Fulfilled',
    Invoiced = 'Invoiced',
    Terminate = 'Terminate',
    Unknown = 'Unknown'
  }